/**
 * @generated SignedSource<<ec4c27f7d0412fc575634bf966ee748f>>
 * @relayHash 270eb0430e64e1c81682d1ffec3a3b20
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 270eb0430e64e1c81682d1ffec3a3b20

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type LineType = "EMERGENCY_LINE" | "KIDS_LINE" | "SWICA_OVERFLOW" | "TELE_GENERAL_PRACTITIONER_LINE";
export type useCallLinesServiceQuery$variables = {
  extensionId?: string | null;
  language?: Language | null;
};
export type useCallLinesServiceQuery$data = {
  readonly ch_telephoneLines: ReadonlyArray<{
    readonly extensionIds: ReadonlyArray<string>;
    readonly id: string;
    readonly key: string;
    readonly lineType: LineType;
    readonly telephoneLineTranslations: ReadonlyArray<{
      readonly content: string;
      readonly id: string;
      readonly language: Language;
    }>;
  }>;
};
export type useCallLinesServiceQuery = {
  response: useCallLinesServiceQuery$data;
  variables: useCallLinesServiceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "extensionId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "extensionId",
        "variableName": "extensionId"
      },
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      }
    ],
    "concreteType": "ch_TelephoneLine",
    "kind": "LinkedField",
    "name": "ch_telephoneLines",
    "plural": true,
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "extensionIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lineType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_TelephoneLineTranslation",
        "kind": "LinkedField",
        "name": "telephoneLineTranslations",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallLinesServiceQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useCallLinesServiceQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "270eb0430e64e1c81682d1ffec3a3b20",
    "metadata": {},
    "name": "useCallLinesServiceQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2943099c8f6df021a04d33e9e45f1c80";

export default node;
